export default __webpack_public_path__ + "static/media/Image.52de4f54.png";